module.exports = __webpack_public_path__ + "media/icons/twitter_w-76f7f2e9.svg";